import { render, staticRenderFns } from "./modern-warm-minimalism.vue?vue&type=template&id=3cf5ba81"
import script from "./modern-warm-minimalism.vue?vue&type=script&lang=js"
export * from "./modern-warm-minimalism.vue?vue&type=script&lang=js"
import style0 from "./modern-warm-minimalism.vue?vue&type=style&index=0&id=3cf5ba81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports